import React, { useState, useEffect, useMemo } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Typography } from '@mui/material'
import StarRating from './StarRating'

const clamp = (n, a, b) => Math.max(a, Math.min(b, n))

export default function PuntuacionDialog({ open, onClose, onSubmit, initial = 5 }) {
  // initial viene como 1..10 (backend). Lo mostramos como 0.5..5 estrellas.
  const initialStars = useMemo(() => {
    const score = Number(initial)
    if (Number.isNaN(score)) return 2.5
    return clamp(score / 2, 0.5, 5)
  }, [initial])

  const [stars, setStars] = useState(initialStars)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (open) setStars(initialStars)
  }, [open, initialStars])

  const score10 = useMemo(() => clamp(Math.round(Number(stars) * 2), 1, 10), [stars])

  const handleSubmit = async () => {
    if (score10 <= 0) return
    try {
      setSubmitting(true)
      await onSubmit(score10) // ✅ seguimos enviando 1..10 al backend
    } finally {
      setSubmitting(false)
    }
  }

  const handleOmitir = async () => {
    try {
      setSubmitting(true)
      await onSubmit(0) // ✅ omitido
    } finally {
      setSubmitting(false)
    }
  }

  const handleClose = (ev, reason) => {
    if (submitting && (reason === 'backdropClick' || reason === 'escapeKeyDown')) return
    onClose?.()
  }

  return (
    <Dialog open={Boolean(open)} onClose={handleClose} disableEscapeKeyDown={submitting} maxWidth="xs" fullWidth>
      <DialogTitle>Puntuar experiencia con el cliente</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <Typography variant="body2">
            Elegí una puntuación (1 a 10) usando estrellas, o omití la valoración.
          </Typography>

          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
            <StarRating
              value={stars}
              onChange={(v) => setStars(v)}
              readOnly={submitting}
              size={26}
              precision={0.5}
              aria-label="puntuación"
            />
            <Typography variant="body2" sx={{ fontWeight: 700, minWidth: 96, textAlign: "right" }}>
              {score10 > 0 ? `${score10}/10` : 'Sin valoración'}
            </Typography>
          </Box>

          <Typography variant="caption" sx={{ opacity: 0.7 }}>
            Tip: media estrella = 1 punto, estrella completa = 2 puntos.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} disabled={submitting}>Cancelar</Button>
        <Button onClick={handleOmitir} disabled={submitting}>Omitir</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={submitting}>Enviar</Button>
      </DialogActions>
    </Dialog>
  )
}
